import React from "react";
import IntlMessages from "@util/IntlMessages";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import RankingSettings from "./RankingSettings";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";

const WidgetSummaryHopps = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="2">
            <RankingSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default WidgetSummaryHopps;
